import React from 'react';
import { motion } from 'framer-motion';

const PeriodicElement = ({ symbol, name, number, isHighlighted, delay = 0, size = 'normal' }) => {
  const bgColor = isHighlighted ? 'bg-bb-green' : 'bg-gray-800';
  const borderColor = isHighlighted ? 'border-bb-green-light' : 'border-green-900';
  const textColor = isHighlighted ? 'text-white' : 'text-gray-400';

  const sizeClasses = {
    small: 'w-16 h-16 text-2xl',
    normal: 'w-20 h-20 sm:w-24 sm:h-24 text-3xl sm:text-4xl',
    large: 'w-28 h-28 sm:w-32 sm:h-32 text-4xl sm:text-5xl'
  };

  return (
    <motion.div
      initial={{ scale: 0, rotateY: 180 }}
      animate={{ scale: 1, rotateY: 0 }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
        delay: delay
      }}
      whileHover={{
        scale: 1.1,
        boxShadow: isHighlighted
          ? "0 0 30px rgba(0, 200, 83, 0.8)"
          : "0 0 20px rgba(0, 200, 83, 0.4)",
        transition: { duration: 0.2 }
      }}
      className={`${sizeClasses[size]} border-2 ${borderColor} ${bgColor} ${textColor} flex flex-col items-center justify-center m-1 cursor-pointer relative overflow-hidden`}
    >
      {/* Glow effect */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-br from-green-400/20 to-transparent opacity-0"
        whileHover={{ opacity: 1 }}
      />

      <div className="text-[10px] sm:text-xs self-start pl-1 absolute top-1 left-1">{number}</div>
      <div className={`font-bold ${size === 'small' ? 'text-xl' : ''}`}>{symbol}</div>
      <div className="text-[8px] sm:text-xs truncate max-w-full px-1">{name}</div>

      {/* Shimmer effect */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full"
        animate={{ translateX: ["−100%", "200%"] }}
        transition={{ duration: 3, repeat: Infinity, repeatDelay: 2 }}
      />
    </motion.div>
  );
};

export default PeriodicElement;
